import { Pipe, PipeTransform } from '@angular/core';

import { Origem } from '../domain';

@Pipe({
    name: 'origem'
})
export class OrigemPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const origem = Origem.getById(value);
        return origem ? origem.nome : '';
    }
}
